import React from "react";

export type AdminEmptyStateProps = {
  title: string;
  description?: string;
  action?: React.ReactNode;
};

/**
 * État vide centré (bordure en pointillés) pour listes / tableaux admin.
 */
export function AdminEmptyState({
  title,
  description,
  action,
}: AdminEmptyStateProps): React.JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-xl border border-dashed border-slate-700 bg-slate-950/40 px-8 py-16 text-center">
      <p className="text-base font-semibold text-white">{title}</p>
      {description ? <p className="max-w-md text-sm text-slate-500">{description}</p> : null}
      {action}
    </div>
  );
}
